import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { PackageStatus } from '../enums/PackageStatus'
import type { PackagePayType } from '../enums/PackagePayType'
import type { PackageItemType } from '../enums/PackageItemType'
import type { PackageDirectionType } from '../enums/PackageDirectionType'
import type { AssignedDriverEntity } from '@/features/livePackage/domain/entities/LivePackageEntity'
import type { CargoStatus } from '../enums/CargoStatus'
import type { OrderPaymentType } from '@/features/order/domain/enums/OrderPaymentType'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'

export class PackageEntity {
  id?: string
  user?: {
    id?: string
    displayName?: string | null
    phoneNumber?: string | null
  }
  serviceId?: number
  serviceName?: string | null
  regionId?: number
  regionName?: string | null
  status?: PackageStatus
  statusUpdatedAt?: string
  address?: PackageAddressEntity
  payType?: PackagePayType
  invoice?: {
    deliveryFee?: number
    serviceFee?: number
    total?: number
    paymentType?: OrderPaymentType
  }
  deliveryFeePrice?: number
  note?: string | null
  senderName?: string | null
  senderPhoneNumber?: string | null
  receiverName?: string | null
  receiverPhoneNumber?: string | null
  directionType?: PackageDirectionType
  vehicleTemplateType?: VehicleTemplateType | null
  imageUrl?: string | null
  itemType?: PackageItemType
  referenceCode?: string | null
  createdAt?: string
  assignedDriver?: AssignedDriverEntity
  latestCargo?: PackageCargoEntity
}

export class PackageAddressEntity {
  source?: LngLatEntity
  sourceAddressName?: string | null
  destination?: LngLatEntity
  destinationAddressName?: string | null
  route?: string | null
  distance?: number
  duration?: number
}
export class PackageCargoEntity {
  id?: string
  packageId?: string
  regionId?: number
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  status?: CargoStatus
  createdAt?: string
  driverEarning?: number
}
